<template>
  <v-container text-xs-center class="mt-4">
    <v-layout row wrap>
      <v-flex 
        xs12 
        md4 
        v-for="(day, index) in events" 
        :key="'day' + index" 
        class="mb-4 pb-2"
      >
        <h3>{{ day.day }}</h3>
        <v-timeline
          align-top
          dense
          light
        >
          <v-timeline-item
            :color="i % 2 ? 'green' : 'red'"
            small
            v-for="(event, i) in day.elements"
            :key="'day' + index + 'event' + i"
          >
            <v-layout pt-3>
              <v-flex xs3>
                <strong>{{ event.hour }}</strong>
              </v-flex>
              <v-flex>
                <strong>{{ event.name }}</strong>
              </v-flex>
            </v-layout>
          </v-timeline-item>
        </v-timeline>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      events: [
        {
          day: 'Piątek - 4 stycznia',
          elements: [
            {
              hour: '16:00',
              name: 'Rejestracja'
            },
            {
              hour: '17:00',
              name: 'Eucharystia'
            },
            {
              hour: '18:00-21:00',
              name: 'Warsztaty'
            }
          ]
        },
        {
          day: 'Sobota - 5 stycznia',
          elements: [
            {
              hour: '08:30',
              name: 'Jutrznia'
            },
            {
              hour: '09:00-13:00',
              name: 'Warsztaty'
            },
            {
              hour: '14:00',
              name: 'Konferencja'
            },
            {
              hour: '14:30-20:00',
              name: 'Warsztaty'
            }
          ]
        },
        {
          day: 'Niedziela - 6 stycznia',
          elements: [
            {
              hour: '09:00-13:00',
              name: 'Warsztaty'
            },
            {
              hour: '14:00-15:30',
              name: 'Warsztaty'
            },
            {
              hour: '16:00',
              name: 'Eucharystia + koncert'
            },
          ]
        }
      ]
    }
  }
}
</script>
